import React, { useRef, useEffect } from 'react';
import useIsMobile from '../../hooks/useIsMobile';

/** Portfolio page background — drifting aurora orbs.
 *  CSS-only (no Three.js). Large blurred gradient circles drift around.
 *  Cheap, gorgeous, mobile-safe.
 */
const ORBS = [
    { color: 'rgba(123, 97, 255, 0.55)', size: 520, dur: 28, delay: 0,   x0: '8%',  y0: '12%' },
    { color: 'rgba(0, 229, 204, 0.45)',  size: 480, dur: 32, delay: 4,   x0: '72%', y0: '18%' },
    { color: 'rgba(255, 61, 138, 0.45)', size: 460, dur: 36, delay: 8,   x0: '30%', y0: '70%' },
    { color: 'rgba(255, 215, 0, 0.32)',  size: 420, dur: 30, delay: 12,  x0: '80%', y0: '74%' },
    { color: 'rgba(123, 97, 255, 0.4)',  size: 360, dur: 26, delay: 6,   x0: '50%', y0: '45%' },
];

const AuroraOrbsBg = () => {
    const ref = useRef(null);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (isMobile) return;
        const root = ref.current;
        if (!root) return;
        const onMouseMove = (e) => {
            const rect = root.getBoundingClientRect();
            const nx = (e.clientX - rect.left) / rect.width - 0.5;
            const ny = (e.clientY - rect.top) / rect.height - 0.5;
            root.style.setProperty('--mx', String(nx * 30));
            root.style.setProperty('--my', String(ny * 30));
        };
        window.addEventListener('mousemove', onMouseMove);
        return () => window.removeEventListener('mousemove', onMouseMove);
    }, [isMobile]);

    return (
        <div
            ref={ref}
            className="absolute inset-0 overflow-hidden pointer-events-none"
            aria-hidden="true"
            data-testid="bg-aurora-orbs"
            style={{ '--mx': 0, '--my': 0 }}
        >
            {ORBS.map((o, i) => (
                <div
                    key={i}
                    className="aurora-orb"
                    style={{
                        width: `${o.size}px`,
                        height: `${o.size}px`,
                        left: o.x0,
                        top: o.y0,
                        background: `radial-gradient(circle, ${o.color} 0%, transparent 70%)`,
                        animation: `auroraDrift ${o.dur}s ease-in-out ${o.delay}s infinite alternate`,
                    }}
                />
            ))}
        </div>
    );
};

export default AuroraOrbsBg;
